// Lecturas de una recarga: sin caché, con concurrencia limitada y cancelación.
// Se utilizan exclusivamente las rutas existentes de la API.
export class CargaLista {
  private cola: any[] = [];
  private activas: any[] = [];
  private cancelada = false;

  constructor(private http: any, private limite = 6, private espera = 30000) {}

  leer(partes: any[]): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      if (this.cancelada) { reject(new Error('Carga cancelada')); return; }
      this.cola.push({ partes, resolve, reject });
      this.continuar();
    });
  }

  cancelar(): void {
    this.cancelada = true;
    this.cola.splice(0).forEach(t => t.reject(new Error('Carga cancelada')));
    this.activas.slice().forEach(t => t.terminar(new Error('Carga cancelada')));
  }

  private continuar(): void {
    while (!this.cancelada && this.activas.length < this.limite && this.cola.length) {
      const tarea = this.cola.shift();
      this.activas.push(tarea);
      let terminada = false;
      let timer: any;
      let peticion: any;
      tarea.terminar = (error?: Error, filas?: any[]) => {
        if (terminada) { return; }
        terminada = true;
        clearTimeout(timer);
        if (peticion) { peticion.unsubscribe(); }
        this.activas.splice(this.activas.indexOf(tarea), 1);
        if (error) { tarea.reject(error); } else { tarea.resolve(filas); }
        this.continuar();
      };
      timer = setTimeout(() => tarea.terminar(new Error('Tiempo de espera agotado')), this.espera);
      const url = 'https://www.panel-control.com/picademo/recursos/sublogin.php/' +
        tarea.partes.map(p => encodeURIComponent(String(p))).join('/');
      try {
        peticion = this.http.get(url).subscribe(res => {
          try {
            const filas = res.json();
            if (!Array.isArray(filas) || filas.some(f => !f || f.error || f.RESULTADO === 'ERROR')) {
              throw new Error('Respuesta no válida');
            }
            tarea.terminar(undefined, filas);
          } catch (error) { tarea.terminar(error); }
        }, () => tarea.terminar(new Error('No se pudo conectar con el servidor')));
        // También soporta respuestas síncronas (por ejemplo, en las pruebas).
        if (terminada && peticion) { peticion.unsubscribe(); }
      } catch (error) { tarea.terminar(error); }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/list/carga-lista.ts